// MC identifies the monitoring service. A model name or SIM phone number does
// not establish that a unit uses SMART Connect.
export const isSmartConnectUnit = unit => /\bsmart\s*connect\b/i.test(unit?.MC || '');
